module.exports = __webpack_public_path__ + "img/NissanLeafMotor.75762d00.jpg";